"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createInputLabelTheme = void 0;
exports.createInputLabelTheme = function (_a) {
    var palette = _a.palette;
    return ({
        root: {
            fontFamily: "Gilroy",
            fontSize: 16,
            color: palette.grey[400],
            padding: "1px 16px",
        },
    });
};
